import { useEffect, useRef, useState } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { setCustomNativeDragPreview } from '@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview';
import { pointerOutsideOfPreview } from '@atlaskit/pragmatic-drag-and-drop/element/pointer-outside-of-preview';

/**
 * Custom hook for making columns draggable
 */
export const useDraggableColumn = ({ columnId, index, isLocked = false }) => {
  const containerRef = useRef(null);
  const handleRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const container = containerRef.current;
    const handle = handleRef.current;

    if (!container || !handle) return;

    // Don't enable dragging for locked columns
    if (isLocked) return;

    const cleanup = draggable({
      element: container,
      dragHandle: handle,
      getInitialData: () => ({
        type: 'column',
        columnId,
        index,
      }),
      onDragStart: () => setIsDragging(true),
      onDrop: () => setIsDragging(false),
      onGenerateDragPreview: ({ nativeSetDragImage }) => {
        setCustomNativeDragPreview({
          nativeSetDragImage,
          getOffset: pointerOutsideOfPreview({ x: '20px', y: '20px' }),
          render: ({ container: previewContainer }) => {
            const clone = container.cloneNode(true);
            clone.style.width = `${container.offsetWidth}px`;
            clone.style.opacity = '0.9';
            clone.style.boxShadow = '0 16px 48px rgba(0,0,0,0.3)';
            previewContainer.appendChild(clone);
          },
        });
      },
    });

    return cleanup;
  }, [columnId, index, isLocked]);

  return {
    containerRef,
    handleRef,
    isDragging,
    isLocked,
  };
};
